import { Injectable } from '@angular/core';
import { ContentService } from '@blk/cwp-ng-framework';
import { ReportGenerationService } from '@ddt-web/common';
import { ComponentData, DisplayDataFactoryService, TransformedComponentData } from '@ddt-web/data-service';
import { ExcelGenerateConfig } from '@ddt-web/domain';
import { combineLatest, Observable } from 'rxjs';
import { first, switchMap } from 'rxjs/operators';

import { ComponentDataTransformerSortingOptions } from '../models/component-data-transformer-sorting-options.interface';
import { ComponentDataTransformerService } from './component-data-transformer.service';

@Injectable()
export class ExcelGenerateService {

	constructor(
		public displayDataFactoryService: DisplayDataFactoryService,
		public contentService: ContentService,
		public reportGenerateService: ReportGenerationService,
		public componentDataTransformerService: ComponentDataTransformerService
	) { }

	public generateExcelFromComponentIds(
		config: ExcelGenerateConfig,
		componentIds: string[],
		id$?: Observable<string[]>,
		sortOptions?: ComponentDataTransformerSortingOptions,
		reportName?: string
	): Observable<ArrayBuffer> {
		const componentData: Array<Observable<ComponentData>> = componentIds.map((componentId: string) => {
			return this.displayDataFactoryService.getDisplayableComponentData(componentId, id$, this.contentService);
		});

		return combineLatest(componentData).pipe(
			first(data => !this.isComponentDataLoading(data)),
			switchMap(completeComponentData => this.generateExcelFromComponentData(config, completeComponentData, sortOptions, reportName))
		);
	}

	public generateExcelFromComponentData(
		config: ExcelGenerateConfig,
		componentData: Array<ComponentData>,
		sortOptions?: ComponentDataTransformerSortingOptions,
		reportName?: string
	): Observable<ArrayBuffer> {
		return this.generateExcelFromTransformedData(
			config,
			this.componentDataTransformerService.transformComponentData(componentData, sortOptions),
			reportName
		);
	}

	public generateExcelFromTransformedData(config: ExcelGenerateConfig, transformedComponentData: TransformedComponentData, reportName?: string): Observable<ArrayBuffer> {
		return this.reportGenerateService.getExcel(config, transformedComponentData, reportName);
	}

	private isComponentDataLoading(componentData: ComponentData[]): boolean {
		for (const data of componentData) {
			if (data.isLoading) {
				return true;
			}
		}
		return false;
	}
}
